import { Nav } from "@/components/site/Nav";
import { Hero } from "@/components/site/Hero";
import { Marquee } from "@/components/site/Marquee";
import { About } from "@/components/site/About";
import { Offerings } from "@/components/site/Offerings";
import { Modalities } from "@/components/site/Modalities";
import { MoonCalendar } from "@/components/site/MoonCalendar";
import { Values } from "@/components/site/Values";
import { ComingSoon } from "@/components/site/ComingSoon";
import { Faq } from "@/components/site/Faq";
import { Contact } from "@/components/site/Contact";
import { Footer } from "@/components/site/Footer";
import { BookingProvider } from "@/components/site/BookingContext";
import { useLenis } from "@/components/site/useLenis";

export default function Home() {
  useLenis();
  return (
    <BookingProvider>
      <div className="grain" aria-hidden />
      <Nav />
      <main>
        <Hero />
        <Marquee />
        <About />
        <Offerings />
        <MoonCalendar />
        <Modalities />
        <Values />
        <ComingSoon />
        <Faq />
        <Contact />
      </main>
      <Footer />
    </BookingProvider>
  );
}
